import React, { useEffect, useState } from "react";
import {
  endInteraction,
  setcontactlist,
  setExternalChatData,
  updateStatus,
  UpdateExternalContactList,
} from "../../../../Redux/Actions/actions";
import { connect } from "react-redux";
import axios from "axios";
import { BaseUrl, emailservice } from "../../../../Container/BaseUrl/BaseUrl";
import { toast } from "react-toastify";
import {
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Stack,
  Button,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { toaststyle } from "../../../../Utils/toaststyle";
import {
  end_call,
  useCompleted,
  useCompletedCampaign,
} from "../../../Utils/Call-utils/call-utils";

const mapStateToProps = (state) => {
  return {
    chatid: state.data.chatid,
    chat: state.data.chat,
    externalChatData: state.contactListData.externalChatData,
    readyButton: state.contactListData.readyButton,
    showingStatus: state.contactListData.showingStatus,
    showingStatusClass: state.contactListData.showingStatusClass,
    showingStatusVoice: state.contactListData.showingStatusVoice,
  };
};

const EndchatModel = (props) => {
  let selectedChat = JSON.parse(localStorage.getItem("client"));
  const completed = useCompleted();
  const completedCampaign = useCompletedCampaign();
  const { OpenDialog, handleClose } = props;
  const [reasonerror, setreasonerror] = useState(false);
  const [comments, setComments] = useState("");
  const [reason, setReason] = useState("");
  const [checkvalue, setCheckvalue] = useState(false);
  const [dispositionlist, setdispositionlist] = useState([]);

  const endChat = () => {
    if (reason === "") {
      setreasonerror(true);
    } else {
      let data = null;
      let userId = JSON.parse(localStorage.getItem("tokenAgent"));
      let agentId = userId.id;
      try {
        const contactType = localStorage.getItem("type");
        if (
          selectedChat?.channel === "voice" &&
          (contactType === "sales" || contactType === "service")
        ) {
          data = {
            chat_session_id: selectedChat?.chat_session_id,
            chatendby: "Agent",
            reason: reason,
            comment: comments || "",
            agent_id: agentId,
            contact_id: localStorage.getItem("ContactVoiceId"),
            voice_type: "contact_voice",
            contact_type: contactType,
          };
        } else {
          data = {
            chat_session_id: selectedChat?.chat_session_id,
            chatendby: "Agent",
            reason: reason,
            comment: comments,
            agent_id: agentId,
            ticket: checkvalue ? checkvalue : "",
          };
        }
        axios
          .post(BaseUrl + "/message/endchat", data, {
            headers: {
              tenantId: localStorage.getItem("TenantId"),
            },
          })
          .then(async (res) => {
            if (res.data.success) {
              localStorage.removeItem("callActivate");
              localStorage.removeItem("type");
              localStorage.removeItem("ContactVoiceId");
              localStorage.removeItem("Contactreg_no");
              if (selectedChat?.channel == "voice") {
                const agentStatus = localStorage.getItem("AgentStatus");
                if (
                  !["Connected", "InCall", "Outbound"].includes(agentStatus)
                ) {
                  end_call();
                  switch (selectedChat?.direction) {
                    case "CM_Outbound":
                      completedCampaign(reason);
                      break;
                    case "MC_Outbound":
                      completed(reason);
                      break;
                    default:
                      props.UpdateExternalContactList(
                        JSON.parse(localStorage.getItem("client"))
                          .chat_session_id,
                      );
                      break;
                  }
                }
                if (
                  !["Connected", "InCall", "Outbound"].includes(agentStatus)
                ) {
                  props.updateStatus("Ready");
                }
              } else {
                props.UpdateExternalContactList(
                  JSON.parse(localStorage.getItem("client")).chat_session_id,
                );
              }
              toast.success("Interaction Ended Successfully", toaststyle);
              handleClose();
            } else {
              toast.error(
                "Failed to end interaction. Please try again.",
                toaststyle,
              );
              handleClose();
              props.setExternalChatData(null);
            }
          })
          .catch((error) => {
            toast.error(
              "Unable to reach server. Please check your connection.",
              toaststyle,
            );
            handleClose();
            props.setExternalChatData(null);
          });
      } catch (error) {
        toast.error(
          "An unexpected error occurred. Please try again.",
          toaststyle,
        );
        handleClose();
        props.setExternalChatData(null);
      }
    }
  };
  const closeTicketApi = async (value) => {
    let sessionId = JSON.parse(localStorage.getItem("client"));
    let dataToPass = {
      ticketID: sessionId.ticketID,
      ticketStatus: checkvalue,
    };

    axios
      .post(emailservice + "/endMailStatusUpdate", dataToPass, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((response) => {
        if (response.data.status) {
          endChat();
        }
      })
      .catch((err) => {});
  };
  const Dispositionlist = async () => {
    await axios
      .post(
        BaseUrl + "/userstatus/dispositionlist",
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        },
      )
      .then((res) => {
        if (res.data.status) {
          setdispositionlist(res.data.data);
        } else {
          setdispositionlist([]);
        }
      })
      .catch((err) => {});
  };
  useEffect(() => {
    if (dispositionlist.length > 0) {
      setReason(
        dispositionlist[0].dispositionName || dispositionlist.dispositionName,
      );
    }
  }, []);

  return (
    <Dialog
      open={OpenDialog}
      keepMounted
      onClose={() => {
        handleClose();
      }}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        variant="subtitle2"
        sx={{
          fontSize: "16px",
          fontWeight: 600,
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
        }}
      >
        End interaction
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          <Stack
            className="mt-3"
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Stack className="fs-13 mb-3">
              <label
                for="exampleFormControlTextarea1"
                className="form-label fs-13"
              >
                Reason*
              </label>
              <select
                className={`form-select fs-13 ${reasonerror ? "is-invalid" : ""}`}
                aria-label="Default select example"
                onChange={(e) => {
                  setReason(e.target.value);
                }}
                onClick={Dispositionlist}
              >
                <option>Select Reason</option>
                {dispositionlist.length > 0 ? (
                  dispositionlist.map((item) => (
                    <option value={item.dispositionName}>
                      {item.dispositionName}
                    </option>
                  ))
                ) : (
                  <></>
                )}
              </select>
            </Stack>
            {reasonerror ? (
              <span className="text-danger fs-12">Choose a reason*</span>
            ) : null}

            <div className="mb-3">
              <label
                for="exampleFormControlTextarea1"
                className="form-label fs-13"
              >
                Comments
              </label>
              <textarea
                onChange={(e) => setComments(e.target.value)}
                style={{ height: "100px" }}
                className="form-control fs-13"
                id="exampleFormControlTextarea1"
                rows="3"
                onKeyDown={(event) => {
                  if (event.keyCode === 13 || event.which === 13) {
                    event.preventDefault();
                    if (reason == "") {
                      setreasonerror(true);
                    } else if (
                      (selectedChat ? selectedChat.channel : "") == "email"
                    ) {
                      closeTicketApi();
                    } else {
                      endChat();
                    }
                  }
                }}
              ></textarea>
            </div>
            <div className="mb-3">
              {selectedChat ? (
                selectedChat.channel === "email" ? (
                  <FormControlLabel
                    className="fs-13"
                    size="small"
                    control={
                      <Checkbox
                        className="fs-13"
                        size="small"
                        checked={checkvalue}
                        onChange={(e) => setCheckvalue(e.target.checked)}
                      />
                    }
                    label="Close Ticket"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "13px",
                      },
                    }}
                  />
                ) : null
              ) : null}
            </div>
          </Stack>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ textTransform: "capitalize !important" }}
          variant="outlined"
          onClick={() => {
            handleClose();
          }}
          size="small"
          disableElevation
          color="error"
          autoFocus
        >
          Close
        </Button>
        <Button
          onClick={() => {
            if (reason == "") {
              setreasonerror(true);
            } else if ((selectedChat ? selectedChat.channel : "") == "email") {
              closeTicketApi();
            } else {
              endChat();
            }
          }}
          vautoFocus
          sx={{ textTransform: "capitalize" }}
          variant="contained"
          disableElevation
          size="small"
          id="submit-btn"
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default connect(mapStateToProps, {
  endInteraction,
  setcontactlist,
  setExternalChatData,
  updateStatus,
  UpdateExternalContactList,
})(EndchatModel);
